import styled from '@emotion/styled'
import { ReactComponent as MailIcon } from 'shop/assets/icons/mail.svg'
import { RiDeleteBin5Line as BinIcon } from 'react-icons/ri'

export const iconDimensions = {
  width: '124px',
  height: '124px'
}

export const StyledMailIcon = styled(MailIcon)(() => ({
  ...iconDimensions,
  color: '#389E0D',
  margin: '0 auto'
}))

export const StyledBinIcon = styled(BinIcon)(({ theme }) => ({
  color: theme.colors.primary
}))
